<template>
  <div class="px-2 sm:px-0">
    <div class="flex w-full flex-col sm:flex-row sm:justify-between mb-3 sm:mb-5">
      <p class="self-start hidden sm:flex sm:self-center text-xl font-bold text-purple_dark">
        {{states.length}} States Infected
      </p>
      <div class="self-end">
        <button
                @click="addState()"
                class="sm:w-full flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white py-2 px-4 hover: rounded-lg">
          <!--          <PlusIcon class="mr-2 self-center" size="1.1x"></PlusIcon>-->

          Add New State
        </button>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <div :key="state.key" class="w-full sm:w-1/2 md:w-1/3 xl:w-1/5  mb-3 sm:mb-6" v-for="state in states">
        <div class="rounded-lg shadow-lg bg-white sm:mr-4">
          <div class="w-full  p-3">
            <p class="text-2xl capitalize text-purple_dark font-semibold">
              {{state.state}}
            </p>
            <p>
              Cases : <span class="font-semibold text-purple">
              {{0 - state.cases}}
            </span>
            </p>


            <p>
              Deaths : <span class="text-red-dark font-semibold"> {{state.deaths}}</span></p>
            <p>
              Recovered : <span class="text-green font-semibold"> {{state.recovered}}</span>
            </p>
            <p>
              Latitude : {{state.lat}}
            </p>
            <p>
              Longitude : {{state.lng}}
            </p>
          </div>
          <div class="flex">
            <button @click="edit(state)"
                    class="w-full bg-blue flex justify-center text-white font-semibold hover:text-white py-2 px-4 rounded-bl-lg">
    <Edit3Icon></Edit3Icon>
            </button>
            <button @click="deleteState(state)"
                    class="w-full hover:bg-red-dark flex justify-center bg-red-medium text-white font-semibold hover:text-white py-2 px-4 rounded-br-lg">
              <Trash2Icon></Trash2Icon>
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import {eventBus} from "../../eventbus";
  import {db} from "../../db";
  import { Trash2Icon,Edit3Icon } from 'vue-feather-icons'

  // import {PlusIcon} from 'vue-feather-icons';
  // import {FingerprintSpinner} from 'epic-spinners'


  export default {
    name: "StatesIndex",
    props: {
      states: {
        type: Array,
        required: true
      },
      statesWithKey: {
        type: Array,
        required: true
      }
    },
    data() {
      return {}
    },
    methods: {
      edit(x) {
        eventBus.$emit('EditState', x)
      },
      addState() {
        eventBus.$emit('AddState')

      },
      deleteState(x) {
        this.$confirm(`Are you sure you want to delete ${x.state} state?`, '',
            "error")
            .then(() => {
              let state = this.statesWithKey.find(item => item.state === x.state);
              db.ref('states/' + `${state.key}`).remove().then(() => {
                this.$toast.open({
                  message: 'Successful',
                  type: 'success'
                });
              })
            })
            .catch(() => {
            });
      }
    },
    components: {
      // PlusIcon,
      Trash2Icon,Edit3Icon
      // FingerprintSpinner
    }
  }
</script>

<style scoped>
  /*.pos {*/
  /*  right: 10px;*/
  /*  bottom: 10px;*/
  /*}*/
</style>
